import { InputsToUpdate } from './api.dto';
export class RowModel {
    rowIndex: number;
    frontInputsToUpdate: InputsToUpdate; // son los mismos campos que IssueUpdateDataSupplier pero con formato para el front
}
